<template>
    <div v-if="options" class="bir_qty_box">
        <input
            v-model="temp"
            class="bir_qty"
            min="1"
            :max="options"
            type="number"
            v-if="new_val > 9"
            @focus="focus = true"
            @blur="blur"
            :disabled="disabled"
        >
        <select
            v-else
            v-model="temp"
            class="bir_qty"
            @change="change"
            @focus="focus = true"
            @blur="focus = false"
            :disabled="disabled"
        >
            <option 
                v-for="(opt,index) in quantity"
                :key="index"
                :value="opt">{{opt == 10 ? opt + '+':opt}}</option>
        </select>
    </div>
</template>

<script>
export default {
    props: [
        'model',
        'options',
        'disabled'
    ],
    data() {
        return {
            new_val: null,
            temp: null,
            focus: false,
        }
    },
    computed:{
        quantity(){
            if(this.options){
                return this.options > 10 ? 10 : this.options
            }
        }
    },
    mounted() {
        this.new_val = this.temp = this.options <= this.model ? 
            this.options
            :this.model
    },
    methods: {
        change(event) {
            if (this.temp == 10 ) { this.new_val = this.temp }
            this.$emit('changed',+ event.target.value)
        },
        blur(e){
           this.temp = +this.temp > this.options ?  this.options : this.temp
           this.focus = false
           this.$emit('changed',+this.temp)
        }
    },
    watch: {
        focus(val) {
            !this.focus ? this.new_val = this.temp : null
        },
        model(val){
            this.new_val = this.temp = this.options <= this.model ? 
                this.options
                :this.model
        }
    }
}
</script>




// WEBPACK FOOTER //
// resources/js/components/partials/SelectBox.vue